import lumaUtils from "@lumarketo/luma-utils";

export const userRoleHasAccessToURL = (companyRoles, userRole, urlSegment) => {
  if (!companyRoles?.length || !userRole || !urlSegment) return false;
  const matchedRole = companyRoles?.find(
    (roleObj) => roleObj?.role === userRole
  );
  if (!matchedRole) return false;

  return matchedRole.accessTo.includes(urlSegment);
};

export const getSuggestions = (
  collections,
  brands,
  categories,
  products,
  useRoutes = true
) => {
  const result = [];
  if (useRoutes)
    result.push(
      ...[
        { label: "Home", value: "/" },
        { label: "Pedir", value: "/pedir" },
        { label: "Cuenta", value: "/mi-cuenta" },
        { label: "Pedidos", value: "/pedidos" },
        { label: "Login", value: "/acceder" },
        { label: "Registrar", value: "/registrar" },
        { label: "Menu QR", value: "/menuqr" },
      ]
    );
  categories?.forEach((category) => {
    result.push({
      label: category.Name,
      value: `/pedir?seccion=${category.Path}`,
    });
  });
  if (products && products.length > 0)
    products.forEach((product) => {
      if (product.Children && product.Children.length > 0)
        product.Children.forEach((child) => {
          result.push({
            label: `${product.Name} - ${child.Size}`,
            value: `/pedir?sku=${child.SKU}`,
          });
        });
    });
  return result;
};
export const getBrandName = (path, brands) => {
  const found = brands.find((brand) => brand.Path === path);
  return found ? found.Name : "Sin marca";
};
export const getCategoryName = (path, categories) => {
  const found = categories.find((category) => category.Path === path);
  return found ? found.Name : "Sin nombre";
};

export const getSubcategoryName = (path, categories) => {
  var found = undefined;
  categories.forEach((c) =>
    c.Category.forEach((s) => {
      if (s.Path === path) found = s;
    })
  );
  return found ? found.Name : "Sin categoría";
};

export const sleep = (time) =>
  new Promise((resolve) => setTimeout(resolve, time));

export const desc = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};
export const getSorting = (a, b, order, orderBy) => {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
};

export const fiscalDocumentValidation = (item) => {
  if (item?.fiscalDocument) {
    // Validate Boleta documents
    if (
      item?.fiscalDocument?.fiscalDocumentType === "Boleta" &&
      item?.fiscalDocument?.documentType &&
      item?.fiscalDocument?.documentNumber
    ) {
      return true;
    }

    // Validate Factura documents
    else if (
      item?.fiscalDocument?.fiscalDocumentType === "Factura" &&
      item?.fiscalDocument?.documentType &&
      item?.fiscalDocument?.documentNumber &&
      item?.fiscalDocument?.fiscalDocumentCompanyName &&
      item?.fiscalDocument?.giro &&
      item?.fiscalDocument?.address &&
      item?.fiscalDocument?.comuna &&
      item?.fiscalDocument?.city
    ) {
      return true;
    }
  }
  return false;
};

export function removeSessionOrderSchedule(key) {
  localStorage.removeItem(key);
}

export function saveSessionOrderSchedule(key, timestamp) {
  const item = {
    expiry: timestamp,
  };

  // Si el item ya existe en el localStorage, entonces lo elimino
  removeSessionOrderSchedule(key);
  localStorage.setItem(key, JSON.stringify(item));
}

export function isSessionOrderScheduleExpired(key) {
  const itemStr = localStorage.getItem(key);

  // Si no existe el item en el localStorage, entonces no ha expirado
  if (!itemStr) return false;

  if (itemStr) {
    const itemFromSessionStorage = JSON.parse(itemStr);
    const now = lumaUtils.dateUtils.momentLib().tz("America/Santiago").unix();
    // Si el tiempo actual es menor al tiempo de expiración, entonces no ha expirado
    if (now < itemFromSessionStorage.expiry) return false;
  }

  // Si el tiempo actual es mayor al tiempo de expiración, entonces ha expirado
  return true;
}

export const getImageFromCloudfront = (image) => {
  const isFromCloudfront = image?.includes(
    "https://dgdvd9d8e5bk8.cloudfront.net/"
  );
  if (isFromCloudfront) return image;
  return image?.replace(
    "https://luma-photos.s3.us-east-1.amazonaws.com/",
    "https://dgdvd9d8e5bk8.cloudfront.net/"
  );
};
